import { createStyles, Theme, withStyles } from '@material-ui/core';
import React from 'react';
import { TypographyAllProps } from 'globals/types';
import FsBodyExtraSmall from 'ui-elements/typography/FsBodyExtraSmall';
import cn from 'classnames';

interface StatusProps extends TypographyAllProps {
  isFullWidth?: boolean;
  bgColor?: string;
  fontColor?: string;
}

export const Status = withStyles(({ palette, spacing }: Theme) =>
  createStyles({
    root: {
      color: palette.common.white,
      background: palette.grey[500],
      padding: spacing(0.5, 1),
      minWidth: 110,
      width: '100%',
      borderRadius: spacing(0.8),
      textAlign: 'center',
      boxSizing: 'border-box',
      '&.isNotFullWith': {
        width: 'auto',
        minWidth: 'auto',
        display: 'inline-block',
        padding: spacing(0.5, 2),
      },
    },
  })
)(({ isFullWidth = true, bgColor, fontColor, ...props }: StatusProps) => (
  <FsBodyExtraSmall
    {...props}
    style={{ backgroundColor: bgColor, color: fontColor }}
    className={cn({ isNotFullWith: !isFullWidth })}
  />
));
